import { mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-radio-item" }
const _hoisted_2 = { class: "pantry-radio-item-value-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "pantry-radio-item-image-view",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickRadio(...args)))
    }, [
      _createVNode("img", _mergeProps(_ctx.selectId, {
        class: "pantry-radio-item-image",
        src: _ctx.getRadioImage()
      }), null, 16, ["src"])
    ]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.valueText), 1)
  ]))
}